import * as R from 'ramda';

const updateFavorites = store => async (state, favoritesList) => {
    try {
        const userClientId = state.user.selectedUserClientId;

        store.setState(
            R.evolve(
                {
                    clients: {
                        [userClientId]: {
                            socialBenchmarking: {
                                favoritesList: R.always(favoritesList),
                            },
                        },
                    },
                },
                store.getState(),
            ),
            true,
        );
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};

export default updateFavorites;
